<script module lang="ts">
  import type { CollectionLink } from '@agapi/mlc-core';

  export interface ProductInfoCollectionsProps {
    collections?: CollectionLink[];
  }
</script>

<script lang="ts">
  import ChildCollections from '../../../components/collection/collection-header/child-collections.svelte';

  const { collections = [] }: ProductInfoCollectionsProps = $props();

  const validCollections = collections.filter(c => c?.title && c?.fullSlug && (c.fullSlug.split('/').length > 3));
</script>

{#if validCollections.length}
  <ChildCollections
    childCollections={validCollections.map((c) => ({ name: c.title, path: c.fullSlug }))}
    isBigger={false}
    forceBlueColor={true}
  />
{/if}
